import { createFileRoute } from "@tanstack/react-router";

import { UrlAnalysisPanel } from "@/features/seonav/url-analysis-panel";

export const Route = createFileRoute("/_authenticated/seonav/url-analysis")({
  component: UrlAnalysisRoute,
});

function UrlAnalysisRoute() {
  return <UrlAnalysisPanel />;
}
